/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Next_TitleInputs */

const en_fc_dl_next_title = /** @type {(inputs: Fc_Dl_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installed? Learn the basics.`)
};

/**
* | output |
* | --- |
* | "Installed? Learn the basics." |
*
* @param {Fc_Dl_Next_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_next_title = /** @type {((inputs?: Fc_Dl_Next_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Next_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_next_title(inputs)
});
export { fc_dl_next_title as "fc.dl.next.title" }